import { useState, useEffect } from 'react'

import { sortSpan, handleSort, performSort, summarizePurchases } from '../auctionsadminutil'

import css from '../sass/adminitem.module.scss'
import adminCss from '../sass/adminpage.module.scss'
import themeCss from '../../components/sass/theme.module.scss'

import { getAuctionStatus } from '../../util/dateString'
import SortNotice from '../SortNotice'
import CategoriesModal from '../CategoriesModal'
import CreateFixedItem from './CreateFixedItem'
import FixedItemEdit from './FixedItemEdit'
import FixedItemDisplayRow from './FixedItemDisplayRow'
import { canEditAuction, isAuctionOwner } from '../permissionsutil'
import ItemListGenerateButton from '../ItemListGenerateButton'

export default function FixedItemDisplay( {selectedAuction, refreshAdminAuctionQuery, hasEnded, 
  fixedItems, setSortedFixedItems, sortedFixedItems, fixedTableFormatter, isUserSR, onArrangeDisplayOrder,
  showArrangeDisplayOrder} ) {
    //need to install

  const [showFixedItemModal, setShowFixedItemModal] = useState(false)
  const [editItem, setEditItem] = useState()
  const [showFixedEditModal, setShowFixedEditModal] = useState(false)
  const [showCategoriesModal, setShowCategoriesModal] = useState(false)
  
  const [displayItems, setDisplayItems] = useState([])
  const [sortOptions, setSortOptions] = useState({ key: '', dir: 'asc' })
  const [hideCloseModalButton, setHideCloseModalButton] = useState()

  const liveStatus = getAuctionStatus(selectedAuction?.StartTime, selectedAuction?.EndTime)
  const isSrApproved = selectedAuction?.ReviewStatus === "Approved"

  const showFixedEditItemModal = () => {
    let newValue = !showFixedEditModal
    setShowFixedEditModal(newValue)
  }

  const updateEditItemId = (id) => {
    const updatedItem = fixedItems.find(ele => ele.FixedItemId === id)
    setEditItem(updatedItem)
    showFixedEditItemModal()
  }

  const showCreateFixedItemModal = () => {
    let newValue = !showFixedItemModal
    setShowFixedItemModal(newValue)
  }

  const showEditFixedItemModal = () => {
    let newValue = !showFixedEditModal
    setShowFixedEditModal(newValue)
  }
  const toggleCategoriesModal = () => {
    let newValue = !showCategoriesModal
    setShowCategoriesModal(newValue)
  }

  useEffect(() => {

    if (fixedItems) {
      const output = fixedItems.map((item) => {
        const adminSummary = summarizePurchases(item?.PurchasePrice || 0, item?.Purchases || [])

        return {
          ...item,
          // BidderFullName: fullName(item.CurrentHighBidderInfo),
          ItemCode: parseInt(item.ItemCode),
          adminSummary,
          TotalItemsRemaining: item.TotalItemsRemaining === null ? Number.POSITIVE_INFINITY : item.TotalItemsRemaining,
          TotalRaised: adminSummary?.Totals?.AmountRaised || 0,
          CurrentBuyers: adminSummary?.Totals?.BuyerCount || 0,
        }
      })
      setDisplayItems(output)
    }

  }, [fixedItems])

  useEffect(() => {

    setSortedFixedItems(performSort(displayItems, sortOptions))

  }, [displayItems, sortOptions])
  
  // maybe provide a link for if no auction is loaded to reroute to load auctions - 404 something
  if (fixedItems.length === 0) return (<></>)
  
  return (
    <>
    
      <h3 className={adminCss['admin-auction-page-tab-header']}>Fixed-Price Items</h3>

      {fixedItems.length !== 0 &&
        <div className={adminCss['admin-auction-items-notices']}>
          {/* {isPreview ? <></> : <p className={themeCss['boldGreen']}>Items in bold green are above Fair Market Value:</p>} */}
          <p>After an item is purchased, you can click on the Amount Purchased to view all of attendees who have purchased the item and their purchase quantity.</p>
          <p>You can click on the Link icon under Actions to copy the individual item's link to your clipboard.</p>
          {!hasEnded && <p>You can click on <b>Arrange Display Order</b> to arrange the order that all items will display in the auction page to the attendees. This will not change the order seen on this page, only what the attendee sees.</p>}
          {hasEnded && isAuctionOwner(selectedAuction) && <p>You can go to the <b>View Attendees</b> tab to Manage Checkout for an individual attendee.</p>}
        </div>
      }

      {!(hasEnded === true && selectedAuction.Status !== 'PREVIEW') && canEditAuction(selectedAuction) && !isUserSR &&
        <div className={css['admin-item-button-header']}>
          <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`} disabled={isSrApproved} onClick={()=> showCreateFixedItemModal()} >
            Add Fixed-Price Item
          </button>
          {showArrangeDisplayOrder &&
            <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={onArrangeDisplayOrder}>
              Arrange Display Order
            </button>
          }
          <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`} onClick={()=> toggleCategoriesModal()} >
            Edit Categories
          </button>
        </div>
        }
      
      <SortNotice />
      <table className={themeCss['data-table']}>
        <thead>
          <tr>
            {!isUserSR && <th>Actions</th>}
            <th></th>
            {fixedTableFormatter.map((ele) => {
              return (
                <th onClick={() => handleSort(ele[0], sortOptions, setSortOptions)} key={ele[1]}>
                {ele[1]} {sortSpan(ele[0], sortOptions)}</th>
              )})}
          </tr>
        </thead>
        <tbody >
          {sortedFixedItems && sortedFixedItems.map((item) => {
            return (
              <FixedItemDisplayRow key={item.FixedItemId} auction={selectedAuction} liveStatus={liveStatus} item={item}
              refreshAdminAuctionQuery={refreshAdminAuctionQuery}
              updateEditItemId={updateEditItemId} hasEnded={hasEnded} isUserSR={isUserSR} />
            )
          })}
        </tbody>
      </table>
      
      {showFixedItemModal && <>
          <div className={themeCss['modal-background']} onClick={()=>showCreateFixedItemModal()}></div>
          <div className={adminCss['auction-modal']}>
            {!hideCloseModalButton && <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={()=>showCreateFixedItemModal()} >Close Modal</button>}
            <CreateFixedItem refreshAdminAuctionQuery={refreshAdminAuctionQuery} auction={selectedAuction} 
              setShowFixedItemModal={setShowFixedItemModal} setHideCloseModalButton={setHideCloseModalButton}/>
          </div>
      </>}
      {showFixedEditModal && <>
          <div className={themeCss['modal-background']} onClick={()=>showFixedEditItemModal()}></div>
          <div className={adminCss['auction-modal']}>
            <FixedItemEdit item={editItem} auction={selectedAuction} refreshAdminAuctionQuery={refreshAdminAuctionQuery} hideCloseModalButton={hideCloseModalButton}
              setShowModal={showEditFixedItemModal} setHideCloseModalButton={setHideCloseModalButton} showFixedEditItemModal={showFixedEditItemModal} />
          </div>
      </>}
      {showCategoriesModal && 
        <>
          <div className={themeCss['modal-background']} onClick={()=>toggleCategoriesModal()}></div>
          <div className={adminCss['auction-modal']}>
            {!hideCloseModalButton && <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={()=>toggleCategoriesModal()} >Close Modal</button>}
            <CategoriesModal refreshAdminAuctionQuery={refreshAdminAuctionQuery} auction={selectedAuction} 
              setShowModal={setShowCategoriesModal} setHideCloseModalButton={setHideCloseModalButton}/>
          </div>
        </>
      }
    </>
  )  
}
